<template>
  <edit v-if="record" :record="record" @onGoBack="handleGoBack" :editMode="true"></edit>
</template>

<script>
import MembershipApi from '@/api/api-cdb-membership'
// 动态切换组件
import Edit from './MembershipEdit'

export default {
  name: 'EditMembershipPage',
  components: {
    Edit
  },
  data () {
    return {
      record: null,
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      const membershipIdOrCode = this.$route.params.membershipIdOrCode
      try {
        const recordRes = await MembershipApi.detail(membershipIdOrCode)
        this.record = recordRes.data
      } catch (e) {
        if (e.message === 'Request failed with status code 404') {
          this.$router.replace('/404')
        }
      }
    },
    handleGoBack () {
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
    },
    record (val) {
      this.record = val
    }
  }
}
</script>
